var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarF = function SvgDefaultAvatarF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6 25.3H33.7c-3.7 0-5.7.3-5.7 1.5 0 .9 1 1.2 3.2 1.3.5.2.7 2.2.7 4.5v15.3c0 2.3-.1 4.3-.7 4.5-2.1.1-3.1.4-3.1 1.3 0 1.2 2.3 1.6 6.3 1.6 4.5 0 6.8-.4 6.8-1.6 0-.9-1-1.2-3.7-1.3-.5-.2-.7-2.3-.7-4.5v-6.1c3.2 0 7.1 0 7.6.8 0 2.4.2 3.4 1.1 3.4 1.2 0 1.7-2.5 1.7-5.5 0-2.9-.5-5.4-1.7-5.4-1 0-1 1-1.1 3.2-.6.8-4.4.8-7.6.8V33c0-2.9.1-4.7 1-4.9h3.5c3.4 0 6.3.3 6.8.9.4.5.7 1.2 1 2.3.6 2.2 1 3.1 1.8 3.1s1.3-.9 1.3-2.4c0-3-1.6-7.5-3.1-7.5-.9.1-.7.8-2.5.8z"
  })));
};
export default SvgDefaultAvatarF;